import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=0966ffd8&scoped=true"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./Breadcrumbs.vue?vue&type=style&index=0&id=0966ffd8&prod&lang=css"
import style1 from "./Breadcrumbs.vue?vue&type=style&index=1&id=0966ffd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0966ffd8",
  null
  
)

export default component.exports